import { render, staticRenderFns } from "./CompareTable.vue?vue&type=template&id=5567859a&"
import script from "./CompareTable.vue?vue&type=script&lang=js&"
export * from "./CompareTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports